import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import TestQuestionnaireHistoryContainer from '../../containers/TestQuestionnaireHistory';
import i18n from '../../resources/i18n';
/**
 * テスト履歴画面
 * @param props
 */
const TestQuestionnaireHistory: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('TestQuestionnaireHistory_0017')} />
			<TestQuestionnaireHistoryContainer {...props} />
		</>
	);
};

export default TestQuestionnaireHistory;



// WEBPACK FOOTER //
// ./src/pages/personal/TestQuestionnaireHistory.tsx